
import React from "react";
import { Button } from "@/components/ui/button";
import { X, Edit, Check } from "lucide-react";

interface NameItemProps {
  id: string;
  name: string;
  category?: string;
  onDelete: (id: string) => void;
  onEdit?: (id: string, newName: string, newCategory: string) => void;
}

const NameItem: React.FC<NameItemProps> = ({ 
  id, 
  name, 
  category, 
  onDelete,
  onEdit
}) => {
  const [isEditing, setIsEditing] = React.useState(false);
  const [editedName, setEditedName] = React.useState(name);
  const [editedCategory, setEditedCategory] = React.useState(category || "");

  const handleEdit = () => {
    if (onEdit && editedName.trim()) {
      onEdit(id, editedName.trim(), editedCategory.trim());
      setIsEditing(false);
    }
  };

  const handleCancel = () => {
    setEditedName(name);
    setEditedCategory(category || "");
    setIsEditing(false);
  };

  return (
    <div className="flex items-center justify-between border p-2 rounded-md bg-white shadow-sm">
      {isEditing ? (
        <div className="flex-1 flex gap-2">
          <input 
            type="text" 
            value={editedName} 
            onChange={(e) => setEditedName(e.target.value)}
            className="flex-1 border rounded px-2 py-1 text-sm"
            placeholder="Name"
          />
          <input 
            type="text" 
            value={editedCategory} 
            onChange={(e) => setEditedCategory(e.target.value)}
            className="w-24 border rounded px-2 py-1 text-sm"
            placeholder="Category"
          />
          <Button size="sm" variant="ghost" onClick={handleCancel}>
            <X className="h-4 w-4" />
          </Button>
          <Button size="sm" variant="ghost" onClick={handleEdit}>
            <Check className="h-4 w-4" />
          </Button>
        </div>
      ) : (
        <>
          <div className="flex-1 flex items-center gap-2">
            <span className="text-sm font-medium">{name}</span>
            {category && (
              <span className="text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded-full">
                {category}
              </span>
            )}
          </div>
          <div className="flex gap-1">
            {onEdit && (
              <Button 
                size="sm" 
                variant="ghost" 
                onClick={() => setIsEditing(true)}
                className="h-7 w-7 p-0"
              >
                <Edit className="h-3.5 w-3.5" />
              </Button>
            )}
            <Button 
              size="sm" 
              variant="ghost" 
              onClick={() => onDelete(id)}
              className="h-7 w-7 p-0 text-red-500 hover:text-red-700 hover:bg-red-50"
            >
              <X className="h-3.5 w-3.5" />
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default NameItem;
